/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { BatchProcessDto } from "../types/batchProcessDto";

import type { BatchProcessItemDtoPaginatedResult } from "../types/batchProcessItemDtoPaginatedResult";

import type { ListBatchProcessItemsParams } from "../types/listBatchProcessItemsParams";

import type { ProblemDetails } from "../types/problemDetails";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_LIST
 */
export const listBatchProcesses = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BatchProcessDto[]>> => {
  return axios.default.get(`/api/batch-processes`, options);
};

export const getListBatchProcessesQueryKey = () => {
  return [`/api/batch-processes`] as const;
};

export const getListBatchProcessesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchProcesses>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchProcesses>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBatchProcessesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchProcesses>>
  > = ({ signal }) => listBatchProcesses({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchProcesses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchProcessesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchProcesses>>
>;
export type ListBatchProcessesQueryError = AxiosError<void>;

export function useListBatchProcesses<
  TData = Awaited<ReturnType<typeof listBatchProcesses>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBatchProcesses>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBatchProcessesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_GET
 */
export const getBatchProcessById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BatchProcessDto>> => {
  return axios.default.get(`/api/batch-processes/${id}`, options);
};

export const getGetBatchProcessByIdQueryKey = (id?: string) => {
  return [`/api/batch-processes/${id}`] as const;
};

export const getGetBatchProcessByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchProcessById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchProcessById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchProcessByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchProcessById>>
  > = ({ signal }) => getBatchProcessById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchProcessById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBatchProcessByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchProcessById>>
>;
export type GetBatchProcessByIdQueryError = AxiosError<void | ProblemDetails>;

export function useGetBatchProcessById<
  TData = Awaited<ReturnType<typeof getBatchProcessById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBatchProcessById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBatchProcessByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_GET
 */
export const listBatchProcessItems = (
  id: string,
  params?: ListBatchProcessItemsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BatchProcessItemDtoPaginatedResult>> => {
  return axios.default.get(`/api/batch-processes/${id}/items`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListBatchProcessItemsQueryKey = (
  id?: string,
  params?: ListBatchProcessItemsParams,
) => {
  return [
    `/api/batch-processes/${id}/items`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListBatchProcessItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchProcessItems>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  params?: ListBatchProcessItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchProcessItems>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchProcessItemsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchProcessItems>>
  > = ({ signal }) =>
    listBatchProcessItems(id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchProcessItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBatchProcessItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchProcessItems>>
>;
export type ListBatchProcessItemsQueryError = AxiosError<void | ProblemDetails>;

export function useListBatchProcessItems<
  TData = Awaited<ReturnType<typeof listBatchProcessItems>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  params?: ListBatchProcessItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBatchProcessItems>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBatchProcessItemsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
